import { render } from "./LeadsViewFullKit.vue?vue&type=template&id=5f58d2ec"
import script from "./LeadsViewFullKit.vue?vue&type=script&lang=js"
export * from "./LeadsViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__